<template>
  <section id="userIndex">
    <alert :data="errorData" :active="activeAlert" :colorAlert="colorAlert" @dialog:change="closeAlert" />

    <v-container fluid>
      <v-row class="justify-between align-center">
        <v-col cols="12" md="auto">
          <BtnRegisterClients />
          <UpdateClient :data="clientInfo" :updateClient="updateActive" @dialog:change="eventdialog" />
        </v-col>

        <v-chip-group class="ml-2" v-model="statusFilter" active-class="success">
          <span class="caption my-auto">Filtrar:</span>
          <!-- <v-chip class="mx-1" label :value="0">
                Todos
              </v-chip> -->
          <v-chip class="mx-1" label value="ACTIVE"> Activos </v-chip>

          <v-chip class="mx-1" label value="INACTIVE"> Inactivos </v-chip>
        </v-chip-group>

        <v-col cols="12" md="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <v-data-table
        :headers="headers"
        :items="FilteredData"
        :search="search"
        :items-per-page="itemsPerPage"
        hide-default-footer
        :page.sync="page"
        @page-count="pageCount = $event"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title class="primary--text text--darken-1 font-weight-medium">
                  {{ item.name }}
                </v-list-item-title>
                <v-list-item-subtitle> {{ item.email }} </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar size="40" tile>
                <v-avatar size="40" :color="$vuetify.theme.dark ? 'blue-grey darken-4' : 'blue-grey lighten-5'">
                  <v-img v-if="item.url_image" :src="item.url_image" alt="Avatar del usuario"></v-img>
                  <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title class="primary--text text--darken-1 font-weight-medium">
                  {{ item.name }}
                </v-list-item-title>
                <v-list-item-subtitle> {{ item.email }} </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip color="transparent" small @click="changeStatus(item)">
            <v-icon left small :color="item.status === 1 ? 'success' : 'error'">mdi-radiobox-marked</v-icon>
            {{ item.status ? "Habilitado" : "Inactivo" }}
          </v-chip>
        </template>

        <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ dateFormat(item.created_at) }}</span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="ShowUsers(item)">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="editClient(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'error' : 'blue-grey'" @click.stop="deleteClient(item)">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </v-card>

    <v-row justify="end">
      <v-col cols="auto">
        <v-pagination circle color="primary" v-model="page" :length="pageCount"></v-pagination>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="750">
      <v-data-table :headers="UsersHeaders" :items="UserInfo">
        <template v-slot:[`item.status`]="{ item }">
          <v-icon left small :color="item.status === 1 ? 'success' : item.status === 3 ? 'warning' : 'error'"
            >mdi-radiobox-marked</v-icon
          >
          {{ item.status == 1 ? "Habilitado" : item.status == 3 ? "Bloqueado" : "Inactivo" }}
        </template>
      </v-data-table>
    </v-dialog>
  </section>
</template>

<script>
import BtnRegisterClients from "@/components/Clients/Register";
import UpdateClient from "@/components/Clients/EditClient";
import alert from "../Utils/Alert";

export default {
  components: {
    BtnRegisterClients,
    UpdateClient,
    alert,
  },
  data() {
    return {
      headers: [
        {
          text: "ID",
          align: "left",
          value: "id",
          class: "primary--text",
          width: "7%",
        },
        {
          text: "Nombre",
          align: "left",
          value: "name",
          class: "primary--text",
          width: "30%",
        },
        {
          text: "Dirección IP",
          value: "ip",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Estado",
          value: "status",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Creado",
          value: "created_at",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "center",
          sortable: false,
        },
      ],
      UsersHeaders: [
        {
          text: "Nombre",
          align: "left",
          sortable: false,
          value: "name",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Correo",
          value: "email",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Estado",
          value: "status",
          class: "primary--text",
          width: "20%",
        },
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      search: "",
      data: [],
      UserInfo: [],
      dialogTableVisible: false,
      dialog: false,
      clientInfo: "",
      updateActive: false,
      statusFilter: undefined,
      errorData: "",
      activeAlert: "",
      colorAlert: "",
    };
  },
  created() {
    this.GetClients();
  },

  computed: {
    Clients() {
      return this.$store.getters["clients/GET_ALL_CLIENTS"];
    },
    FilteredData() {
      if (!this.statusFilter) return this.data;
      return this.data.filter(({ status }) => (this.statusFilter === "ACTIVE" ? status === 1 : status === 0));
    },
  },

  methods: {
    dateFormat(date) {
      const dateFormatted = date
        .toString()
        .slice(0, 10)
        .split("-")
        .reverse()
        .join("/");
      return dateFormatted;
    },

    async GetClients() {
      try {
        const response = await this.$store.dispatch("clients/SHOW_CLIENTS");
        this.data = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    ShowUsers(users) {
      // console.log(users);
      this.dialog = true;
      this.UserInfo = users.user_relation;
      // console.log(this.UserInfo);
    },
    editClient(client) {
      // this.clientInfo = client;
      this.clientInfo = {
        id: client.id,
        name: client.name,
        user: client.user,
        email: client.email,
        password: client.password,
        agent: client.agent,
        supervisor: client.supervisor,
        plan_id: client.plan_id,
        ip_recording: client.ip_recording,
        ip: client.ip,
        nameBd: client.nameBd,
        port: client.port,
        ip_sokect: client.ip_sokect,
        user_sokect: client.user_sokect,
        clave_sokect: client.clave_sokect,
        port_sokect: client.port_sokect,
        web_socket_server_url: client.web_socket_server_url,
        domain_bitrix: client.domain_bitrix,
        key_bitrix: client.key_bitrix,
        has_signature: client.has_signature,
        journal: client.journal,
      };
      this.updateActive = true;
      console.log(client);
    },
    async deleteClient(client) {
      this.clientInfo = client;
      const response = await this.$store.dispatch("clients/DELETE_CLIENTS", {
        id: client.id,
      });
      this.errorData = response.data;
      this.activeAlert = true;
      this.colorAlert = "blue";
      // console.log(response);
    },
    eventdialog(message) {
      this.updateActive = false;
      if (message !== "cerrar") {
        this.errorData = "Cliente Actualizado";
        this.activeAlert = true;
        this.colorAlert = "blue";
      }
    },
    closeAlert() {
      this.activeAlert = false;
    },
    async changeStatus(value) {
      // console.log("Prueba", value);
      const conf = confirm("CAMBIAR ESTATUS");
      if (conf) {
        await this.$store.dispatch("clients/CHANGE_STATUS", {
          id: value.id,
        });
      }
    },
  },
};
</script>
